import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';

export interface ParametroSearchDocumento {
	alfrescoCMISQueryFragment?: string;
	alfrescoQueryFragment?: string;
	/** Nome del metadato */
	id: string;
	/** tipo della ricerca. Puo essere:
	 * "lower" cerca risultati inferiori a valore,
	 * "greater" cerca risultati superiori a valore
	 * "equal" (default) cerca risultati uguali a valore
	 * "between" cerca risultati intermedi tra valore e valore2
	 */
	type: 'lower' | 'greater' | 'equal' | 'between';
	/** Valore da cercare */
	valore: string;
	/** Valore da cercare per il tipo "between" */
	valore2?: string;
}

export interface CreateDocumentoRequest {
	/** contenuto del file in Base64 */
	base64?: string;
	/** descrizione del documento */
	descrizione?: string;
	/** contenuto del file in byte array */
	fileContent?: string;
	/** nome file del documento */
	fileName: string;
	/** i parametri sono una lista
	 * [id] Nome del metadato
	 * [valore] Valore
	 */
	parametri: {
		id: string;
		valore: string;
	}[];
}

export interface AddAllegatoRequest {
	/** contenuto del file in Base64 */
	base64?: string;
	/** contenuto del file in byte array */
	fileContent?: string;
	/** nome file dell'allegato */
	fileName: string;
	/** descrizione dell'allegato */
	descrizione?: string;
}

@Injectable({ providedIn: 'root' })
export class WSService {
	wsApiUrl: string;

	constructor(
		appConfig: AppConfig,
		private http: HttpClient,
	) {
		this.wsApiUrl = appConfig.get('wsApiUrl');
	}

	getMetadatiClasseDocumentale(idClasseDocumentale: string) {
		return this.http.get(this.wsApiUrl + `/metadati/${idClasseDocumentale}`);
	}

	getGraffettatura(idDocumento: string) {
		return this.http.get(this.wsApiUrl + `/graffetta/${idDocumento}`);
	}

	aggiungiGraffettatura(idDocumento: string, riferimento: string) {
		return this.http.post(this.wsApiUrl + `/graffetta/${idDocumento}`, riferimento);
	}

	rimuoviGraffettatura(idDocumentoPrecede: string, idDocumentoSegue: string) {
		return this.http.delete(this.wsApiUrl + `/graffetta/${idDocumentoPrecede}/${idDocumentoSegue}`);
	}

	versionaDocumento(idDocumento: string, body: any) {
		return this.http.post(this.wsApiUrl + `/versionaDocumento/${idDocumento}`, body);
	}

	getConfigurazioniTenant(idTenant: string) {
		return this.http.get(this.wsApiUrl + `/tenant/${idTenant}`);
	}

	deleteNode(idDocumento: string) {
		return this.http.delete(this.wsApiUrl + `/deleteDocumento/${idDocumento}`);
	}

	updateDocumento(tipoDoc: string, idDocumento: string, body: any) {
		return this.http.put(this.wsApiUrl + `/updateDocumento/${tipoDoc}/${idDocumento}`, body);
	}

	getDomini(idTenant: string) {
		return this.http.get(this.wsApiUrl + `/domini/${idTenant}`);
	}

	getDominio(idTenant: string, idDominio: string) {
		return this.http.get(this.wsApiUrl + `/domini/${idTenant}/${idDominio}`);
	}

	aggiungiDominio(idTenant: string, idDominio: string, valore: string) {
		return this.http.post(this.wsApiUrl + `/domini/v2/${idTenant}/${idDominio}`, valore);
	}

	searchDocumento(idTenant: string, idClasseDocumentale: string, body: ParametroSearchDocumento[]) {
		return this.http.post(this.wsApiUrl + `/searchDocumento/${idTenant}/${idClasseDocumentale}`, body);
	}

	createDocumento(idTenant: string, idClasseDocumentale: string, body: CreateDocumentoRequest) {
		return this.http.post(this.wsApiUrl + `/createDocumento/${idTenant}/${idClasseDocumentale}`, body);
	}

	addAllegato(idTenant: string, idDocumento: string, body: AddAllegatoRequest) {
		return this.http.post(this.wsApiUrl + `/addAllegato/${idTenant}/${idDocumento}`, body);
	}
}
